import React from "react";
import Link from "../../components/Link";
import AccountLayout from "../../account/AccountLayout";
import { useAuth } from "../../auth/AuthProvider";
import { useAccount } from "../../account/AccountProvider";
import { AccountButton, AccountCard, AccountStatus } from "../../account/AccountUi";
import { accountLabel } from "../../account/userDisplay";
import { formatDate } from "../../account/entitlementAdapter";

export default function AccountOverviewPage() {
  return (
    <AccountLayout
      title="Overview"
      description="Your Stratify account, plan, and settings."
      path="/account"
    >
      <OverviewBody />
    </AccountLayout>
  );
}

function OverviewBody() {
  const auth = useAuth();
  const { profile, profileState, entitlement, entitlementState, reloadEntitlement, reloadProfile } = useAccount();

  return (
    <div className="space-y-5">
      <AccountCard>
        <p className="text-xs font-semibold uppercase tracking-wide text-muted">Signed in</p>
        <p className="mt-2 text-lg font-semibold text-ink">{accountLabel(auth.user)}</p>
        <p className="mt-1 text-sm text-muted">{auth.email || profile?.email || "Google account"}</p>
        {profileState === "loading" ? <AccountStatus>Loading profile…</AccountStatus> : null}
        {profileState === "error" ? (
          <div className="mt-3">
            <AccountStatus tone="error">We couldn’t load your profile.</AccountStatus>
            <AccountButton variant="secondary" className="mt-3" onClick={reloadProfile}>
              Try again
            </AccountButton>
          </div>
        ) : null}
      </AccountCard>

      <AccountCard>
        <p className="text-xs font-semibold uppercase tracking-wide text-muted">Subscription</p>
        {entitlementState === "loading" && !entitlement ? (
          <AccountStatus>Checking your plan…</AccountStatus>
        ) : entitlement ? (
          <>
            <p className="mt-2 text-lg font-semibold text-ink">{entitlement.headline}</p>
            <p className="mt-1 text-sm text-muted">{entitlement.detail}</p>
            {entitlement.freshness === "stale" ? (
              <p className="mt-2 text-xs text-muted">
                Showing the last confirmed label for this account. Access is not granted from cache.
              </p>
            ) : null}
            {entitlement.currentPeriodEnd ? (
              <p className="mt-2 text-sm text-muted">Period end: {formatDate(entitlement.currentPeriodEnd)}</p>
            ) : null}
          </>
        ) : (
          <AccountStatus>We couldn’t confirm your subscription.</AccountStatus>
        )}
        <div className="mt-4 flex flex-wrap gap-3">
          <AccountButton variant="secondary" onClick={reloadEntitlement}>
            Refresh plan
          </AccountButton>
          <Link
            to="/account/billing"
            className="inline-flex min-h-11 items-center justify-center rounded-xl px-4 text-sm font-semibold text-ink/80 ring-1 ring-ink/10 hover:bg-bg1"
          >
            Manage billing
          </Link>
        </div>
      </AccountCard>

      <AccountCard>
        <p className="text-sm text-muted">
          Account pages do not run backtests or market-data work. Use the iPhone app for Bot Trader, Building Strategies, and
          Strategy Discovery.
        </p>
      </AccountCard>
    </div>
  );
}
